import { Transform } from 'class-transformer';
import { IsOptional } from 'class-validator';
import { AccountAddressDto } from '../account-addresses/account-address.dto';
import { sanitizeString } from '../utils';
import { CasePickupContactDto } from './case-pickup-contact.dto';
import { PackageDimensions } from './package-dimensions.dto';

/**
 * DTO used to send pickup information while updating a Return Case
 */
export class CasePickupUpdateDto {
  @IsOptional()
  @Transform(({ value }) => sanitizeString(value))
  public addressNotes?: string;

  @IsOptional()
  @Transform(({ value }) => sanitizeString(value))
  public customerReference?: string;

  public contact: CasePickupContactDto;

  public address?: AccountAddressDto;

  public weightUnit: string;

  public restrictedAccess: boolean;

  public tailLiftRequired: boolean;

  public pickupDate: Date;

  public totalPackageWeight: number;

  public singlePackageWeight: number;

  public dimensions: PackageDimensions;
}
